import { useTranslation } from "react-i18next"
import { TFunction } from "i18next"

export default () => {
	const { t } = useTranslation("surveys", { keyPrefix: "form.dataTableHeaders" })

	return columns(t)
}

const columns = (t: TFunction) => [
	{
		key: "id",
		title: "ID",
		dataIndex: "id"
	},
	{
		title: t("name"),
		dataIndex: "name",
		key: "name"
	},
	{
		title: t("description"),
		dataIndex: "description",
		key: "description"
	},
	{
		key: "order",
		title: t("order"),
		dataIndex: "order"
	},
	{
		title: "",
		dataIndex: "editButton",
		key: "editButton"
	}
]
